/**
 301 : 토큰 복호화 실패
 302 : 토큰 유효기간 만료
 303 : 토큰 검증 -> 회원정보 없음
 ~~304 : 토큰 검증 -> 퇴원생~~
 ~~305 : 토큰 검증 -> 학부모 자녀 퇴원생임~~
 307 : 토큰 검증 -> 접속 차단 회원
 ~~308 : 토큰 검증 -> 재원생/학부모 아닌 회원~~
 309 : 토큰 검증 ->  DB 토큰 불일치
 310 : 개인 정보 변경/삭제로 인한 만료 처리

 501 : Parameter 필수값 널
 401 : method 실패 처리

 601 기타
 */

export const returnCode = {
  result_code : '100',
  decode_failed: '301',
  token_expired: '302',
  token_not_found: '303',
  token_invalid_student: '306',
  token_invalid_student_parent: '307',
  token_invalid_db: '309',
  token_invalid_change_info: '310',
  // other: '601',
  withe_result_codes: ['500'],
}